// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import {Settings_context} from '../settings_ctx';
import cn from 'classnames';
import {Svg_img} from '../ui/svg_img';
import {Editor} from '../../../shared/editor/editor';
import {use_screen} from '../lib/screen_util';
import {Button} from '../../../shared/button';
import {open_store} from '../ui/install_btn';
import {use_download} from '../shared/use_download';
import {guess_os_and_version} from '../client_hints_global';
import {useHistory} from 'react-router';
import styles from './choose_your_vpn_cards.module.less';

const Puzzle_img = ()=>{
    return <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M13.0059 1C15.2065 1.00026 16.9902 2.78461 16.9902
        4.98535C16.9902 4.9935 16.9903 5.00163 16.9902 5.00977H19.0205C20.114
        5.00977 21.001 5.8967 21.001 6.99023V10.1689C21.001 10.4861 20.8467
        10.7836 20.5879 10.9668C20.3288 11.15 19.9964 11.1966 19.6973
        11.0908C19.4869 11.0165 19.2595 10.9756 19.0205 10.9756C17.8993
        10.9756 16.9902 11.8847 16.9902 13.0059C16.9905 14.1268 17.8995
        15.0351 19.0205 15.0352C19.2595 15.0352 19.4869 14.9943 19.6973
        14.9199C19.9964 14.8142 20.3288 14.8607 20.5879 15.0439C20.8467
        15.2272 21.001 15.5246 21.001 15.8418V19.0205C21.001 20.114 20.114
        21.001 19.0205 21.001H6.99023C5.89671 21.001 5.00977 20.114 5.00977
        19.0205V16.9902C5.00163 16.9903 4.99349 16.9902 4.98535 16.9902C2.78461
        16.9902 1.00026 15.2065 1 13.0059C1 10.805 2.78445 9.02051 4.98535
        9.02051C4.9935 9.02051 5.00163 9.02046 5.00977 9.02051V6.99023C5.00977
        5.89671 5.8967 5.00977 6.99023 5.00977H9.02051C9.02046 5.00163 9.02051
        4.9935 9.02051 4.98535C9.02051 2.78445 10.805 1 13.0059 1ZM13.0059
        2.5C11.6334 2.5 10.5205 3.61288 10.5205 4.98535C10.5205 4.99056
        10.5205 4.99584 10.5205 5.00098C10.5229 5.40036 10.3655 5.78409 10.084
        6.06738C9.80246 6.35061 9.41985 6.50973 9.02051 6.50977H6.99023C6.72513
        6.50977 6.50977 6.72513 6.50977 6.99023V9.02051C6.50973 9.41985 6.35061
        9.80246 6.06738 10.084C5.78409 10.3655 5.40036 10.523 5.00098
        10.5205C4.99583 10.5205 4.99056 10.5205 4.98535 10.5205C3.61288
        10.5205 2.5 11.6334 2.5 13.0059C2.50026 14.3781 3.61304 15.4902
        4.98535 15.4902C4.99056 15.4902 4.99583 15.4903 5.00098
        15.4902C5.40036 15.4878 5.78409 15.6452 6.06738 15.9268C6.35061
        16.2083 6.50973 16.5909 6.50977 16.9902V19.0205C6.50977 19.2856
        6.72513 19.501 6.99023 19.501H19.0205C19.2856 19.501 19.501 19.2856
        19.501 19.0205V16.499C19.3436 16.5205 19.1835 16.5352 19.0205
        16.5352C17.0711 16.5351 15.4905 14.9552 15.4902 13.0059C15.4902
        11.0562 17.0709 9.47564 19.0205 9.47559C19.1834 9.47559 19.3436
        9.48928 19.501 9.51074V6.99023C19.501 6.72513 19.2856 6.50977
        19.0205 6.50977H16.9902C16.5909 6.50973 16.2083 6.35061 15.9268
        6.06738C15.6452 5.78409 15.4878 5.40036 15.4902 5.00098C15.4903
        4.99583 15.4902 4.99056 15.4902 4.98535C15.4902 3.61304 14.3781
        2.50026 13.0059 2.5Z" fill="#71BBFF"/>
    </svg>;
};

const Globe_img = ()=>{
    return <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5
        17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5
        6.20101 22.5 12ZM8.73256 20.3885C7.20576 18.7332 6.15904 15.9513
        6.01662 12.75H3.03081C3.31881 16.2411 5.59934 19.1672 8.73256
        20.3885ZM9.0436 18.2993C8.21215 16.9136 7.62682 14.9735 7.51823
        12.75H11.25V20.3661C10.5184 20.1074 9.73991 19.4599 9.0436
        18.2993ZM12.75 20.3661C13.4816 20.1074 14.2601 19.4599 14.9564
        18.2993C15.7878 16.9136 16.3732 14.9735 16.4818
        12.75H12.75V20.3661ZM12.75 11.25H16.4818C16.3732 9.02649 15.7878
        7.08642 14.9564 5.70068C14.2601 4.54015 13.4816 3.89257 12.75
        3.63394V11.25ZM11.25 3.63394C10.5184 3.89257 9.73991 4.54015
        9.0436 5.70068C8.21215 7.08642 7.62682 9.02649 7.51823
        11.25H11.25V3.63394ZM15.2674 20.3885C16.7942 18.7332 17.841 15.9513
        17.9834 12.75H20.9692C20.6812 16.2411 18.4007 19.1672 15.2674
        20.3885ZM17.9834 11.25H20.9692C20.6812 7.75891 18.4007 4.8328
        15.2674 3.61148C16.7942 5.26684 17.841 8.04868 17.9834
        11.25ZM3.03081 11.25H6.01662C6.15904 8.04868 7.20576 5.26684
        8.73255 3.61148C5.59933 4.8328 3.31881 7.75891 3.03081 11.25Z"
        fill="#FFB9F8"/>
    </svg>;
};

const Laptop_img = ()=>{
    return <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M22 17H2V19C2 19.5523 2.44772 20 3 20H21C21.5523 20 22
        19.5523 22 19V17Z" stroke="#0A9F68" stroke-width="1.5"
        stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M19 5H5C4.44772 5 4 5.44772 4 6V16C4 16.5523 4.44772 17 5
        17H19C19.5523 17 20 16.5523 20 16V6C20 5.44772 19.5523 5 19 5Z"
        stroke="#0A9F68" stroke-width="1.5" stroke-linecap="round"
        stroke-linejoin="round"/>
    </svg>;
};

const Mobile_img = ()=>{
    return <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M12 16C12.5523 16 13 16.4477 13 17C13 17.5523 12.5523 18 12
        18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16Z"
        fill="#71BBFF"/>
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M16.25 3C17.2165 3 18 3.7835 18 4.75V19.25C18 20.2165 17.2165
        21 16.25 21H7.75C6.7835 21 6 20.2165 6 19.25V4.75C6 3.7835 6.7835
        3 7.75 3H16.25ZM7.75 4.5C7.61193 4.5 7.5 4.61193 7.5
        4.75V19.25C7.5 19.3881 7.61193 19.5 7.75 19.5H16.25C16.3881 19.5
        16.5 19.3881 16.5 19.25V4.75C16.5 4.61193 16.3881 4.5 16.25
        4.5H7.75Z" fill="#71BBFF"/>
    </svg>;
};

const TV_img = ()=>{
    return <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M10.75 8C11.1642 8 11.5 8.33579 11.5 8.75C11.5 9.16421
        11.1642 9.5 10.75 9.5H9.5V14.25C9.5 14.6642 9.16421 15 8.75
        15C8.33579 15 8 14.6642 8 14.25V9.5H6.75C6.33579 9.5 6 9.16421 6
        8.75C6 8.33579 6.33579 8 6.75 8H10.75Z" fill="#FFB9F8"/>
      <path d="M16.2949 8.49414C16.4364 8.10508 16.8668 7.90383 17.2559
        8.04492C17.645 8.18642 17.8463 8.61671 17.7051 9.00586L15.7051
        14.5059C15.5973 14.8022 15.3154 15 15 15C14.6847 14.9999 14.4027
        14.8022 14.2949 14.5059L12.2949 9.00586C12.1538 8.61679 12.3552
        8.18647 12.7441 8.04492C13.1333 7.90371 13.5635 8.10508 13.7051
        8.49414L15 12.0547L16.2949 8.49414Z" fill="#FFB9F8"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M20.25 4C21.2165 4
        22 4.7835 22 5.75V16.75C22 17.7165 21.2165 18.5 20.25
        18.5H12.75V19.5H15C15.4142 19.5 15.75 19.8358 15.75 20.25C15.75
        20.6642 15.4142 21 15 21H9C8.58579 21 8.25 20.6642 8.25
        20.25C8.25 19.8358 8.58579 19.5 9 19.5H11.25V18.5H3.75C2.7835
        18.5 2 17.7165 2 16.75V5.75C2 4.7835 2.7835 4 3.75 4H20.25ZM3.75
        5.5C3.61193 5.5 3.5 5.61193 3.5 5.75V16.75C3.5 16.8881 3.61193 17
        3.75 17H20.25C20.3881 17 20.5 16.8881 20.5 16.75V5.75C20.5
        5.61193 20.3881 5.5 20.25 5.5H3.75Z" fill="#FFB9F8"/>
    </svg>;
};

const Joystick_img = ()=>{
    return <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M7.49414 7C7.90832 6.99946 8.24454 7.33483 8.24512
        7.74902L8.24609 8.74609L9.24902 8.74512C9.6632 8.74458 9.99942
        9.07995 10 9.49414C10.0005 9.90827 9.66513 10.2445 9.25098
        10.2451L8.24805 10.2461L8.25 11.249C8.25054 11.6632 7.91517
        11.9994 7.50098 12C7.0868 12.0005 6.75058 11.6652 6.75
        11.251L6.74805 10.248L5.75098 10.25C5.33684 10.2505 5.00064
        9.91511 5 9.50098C4.99946 9.0868 5.33483 8.75058 5.74902
        8.75L6.74609 8.74805L6.74512 7.75098C6.74458 7.3368 7.07995
        7.00058 7.49414 7Z" fill="#0A9F68"/>
      <path d="M15 10C15.5523 10 16 10.4477 16 11C16 11.5523 15.5523 12 15
        12C14.4477 12 14 11.5523 14 11C14 10.4477 14.4477 10 15 10Z"
        fill="#0A9F68"/>
      <path d="M17 7C17.5523 7 18 7.44772 18 8C18 8.55228 17.5523 9 17
        9C16.4477 9 16 8.55228 16 8C16 7.44772 16.4477 7 17 7Z"
        fill="#0A9F68"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M19 4C20.6569 4 22
        5.34315 22 7V17C22 18.6569 20.6569 20 19 20H18.7324L18.5322
        19.9932C17.5383 19.927 16.6362 19.3702 16.1338 18.5L14.6904
        16C14.3555 15.4199 13.7544 15.049 13.0918 15.0049L12.959
        15H11.1328L11.001 15.0039C10.3494 15.0467 9.7558 15.4061 9.41699
        15.9707L7.87402 18.5439L7.76758 18.709C7.20976 19.5142 6.28956
        19.9999 5.30176 20H5C3.34315 20 2 18.6569 2 17V7C2 5.34315 3.34315
        4 5 4H19ZM5 5.5C4.17157 5.5 3.5 6.17157 3.5 7V17C3.5 17.8284
        4.17157 18.5 5 18.5H5.30176C5.82853 18.4999 6.31686 18.2232
        6.58789 17.7715L8.13086 15.1992C8.76339 14.145 9.90339 13.5
        11.1328 13.5H12.959C14.2092 13.5002 15.3641 14.1673 15.9893
        15.25L17.4326 17.75L17.5439 17.915C17.8256 18.2808 18.2634 18.5
        18.7324 18.5H19C19.8284 18.5 20.5 17.8284 20.5 17V7C20.5 6.17157
        19.8284 5.5 19 5.5H5Z" fill="#0A9F68"/>
    </svg>;
};

interface i_card_props {
    type?: 'free' | 'premium';
    image: React.ReactNode;
    title: string;
    description: string;
    advantages: string[];
    button_params: {
        cta: string;
        action: 'add_to_browser' | 'download_browser'
            | 'download_desktop_app' | 'download_mobile_app' | 'smart_tv'
            | 'other_devices';
    };
    with_badge?: boolean;
}

const cards_data: i_card_props[] = [
    {
        type: 'free',
        image: <Puzzle_img />,
        title: 'Browser Extension',
        description: 'Add Hola VPN to Chrome, Edge, or Opera to unblock '
            +'sites.',
        advantages: [
            'One-click activation',
            'Per-tab location switching',
            'Lightweight and fast',
        ],
        button_params: {
            cta: 'Add to browser',
            action: 'add_to_browser',
        },
    },
    {
        type: 'free',
        image: <Globe_img />,
        title: 'Hola Browser',
        description: 'An all-in-one browser for Win and macOS for browsing '
            +'across global locations.',
        advantages: [
            'One-click connect built-in VPN',
            'Multiple locations',
            'Simple, streamlined experience',
        ],
        button_params: {
            cta: 'Download',
            action: 'download_browser',
        },
    },
    {
        type: 'free',
        image: <Laptop_img />,
        title: 'VPN for Desktop',
        description: 'System-wide VPN for Win and macOS with one-click '
            +'connect and easy setup.',
        advantages: [
            'Works with all apps and browsers',
            'Auto-connect on launch',
            'Switch between locations',
        ],
        button_params: {
            cta: 'Download',
            action: 'download_desktop_app',
        },
    },
    {
        type: 'free',
        image: <Mobile_img />,
        title: 'VPN for Mobile',
        description: 'Easy-to-use VPN for iOS and Android with reliable '
            +'protection on Wi-Fi and cellular.',
        advantages: [
            'Simple, step-by-step setup',
            'Fast browsing and streaming',
            'Choose from many locations',
        ],
        button_params: {
            cta: 'Get app',
            action: 'download_mobile_app',
        },
    },
    {
        type: 'free',
        image: <TV_img />,
        title: 'VPN for Smart TV',
        description: 'Watch content on Android TV, Fire TV, and Apple TV '
            +'with a remote-friendly UI',
        advantages: [
            'Native apps',
            'Switch countries in a few taps',
            'Reliable on Wi-Fi and Ethernet',
        ],
        button_params: {
            cta: 'Get TV app',
            action: 'smart_tv',
        },
    },
    {
        type: 'premium',
        image: <Joystick_img />,
        title: 'Other Devices',
        // XXX dmitriikup: URG request from noav to remove all Samsung
        // mentions from www
        // description: 'Smart DNS for Samsung TV, webOS, Xbox, PlayStation, '
        //     +'supported routers, and more',
        description: 'Smart DNS for webOS, Xbox, PlayStation, '
            +'supported routers, and more',
        advantages: [
            'Easy step-by-step guides',
            'No app required',
            'For devices without VPN app support',
        ],
        button_params: {
            cta: 'Setup guides',
            action: 'other_devices',
        },
    },
];

const use_card_button = (action: i_card_props['button_params']['action'])=>{
    const {screen} = use_screen();
    const is_mobile = screen=='xs' || screen=='sm';
    const sys = guess_os_and_version();
    const history = useHistory();
    const {download, download_br} = use_download({});
    const handle_click = ()=>{
        switch (action)
        {
        case 'add_to_browser':
            if (is_mobile)
                return history.push('/products/extension');
            return open_store();
        case 'download_browser':
            if (is_mobile)
                return history.push('/products/browser');
            return download_br({});
        case 'download_desktop_app':
            if (is_mobile)
                return history.push('/products/desktop');
            return download({});
        case 'download_mobile_app':
            if (is_mobile)
            {
                if (sys.os=='android')
                {
                    return window.location.href =
                        'https://play.google.com/store/apps/details'
                        +'?id=org.hola';
                }
                if (sys.os=='ios')
                {
                    return window.location.href =
                        'https://apps.apple.com/app/hola-vpn/'
                        +'id1224887640';
                }
            }
            return history.push('/products/mobile');
        case 'smart_tv':
            return history.push('/products/tv');
        case 'other_devices':
            return history.push('/products/console');
        }
    };
    return {handle_click};
};

const Badge = (props: {type: 'free' | 'premium'})=>{
    const {theme} = useContext(Settings_context);
    const text = props.type==='free' ? 'Free' : 'Premium';
    return <div className={cn(styles.badge,
      {[styles.badge_premium]: props.type==='premium'})}>
      <p className={cn([theme.p5, theme.bold, styles.badge_text,
        theme.color_n600],
        {[theme.color_n700]: props.type==='premium'})}>
        {text}
      </p>
    </div>;
};

const Card = (props: i_card_props)=>{
    const {theme} = useContext(Settings_context);
    const {handle_click} = use_card_button(props.button_params.action);
    return <div className={styles.card}>
      <div>{props.image}</div>
      {props.with_badge && <Badge type={props.type} />}
      <div className={styles.title_description}>
        <p className={cn([theme.u2, theme.med, theme.color_n700])}>
          {props.title}</p>
        <p className={cn([theme.p4, theme.reg])}>
          {props.description}</p>
      </div>
      <div className={styles.advantages_container}>
        {props.advantages.map((a, idx)=><div key={idx}
          className={styles.advantage}>
          <Svg_img id={'hola2023/icons/18/check.svg'} w={18} h={18} />
          <p className={cn([theme.p3, theme.reg, theme.color_n700])}>{a}</p>
        </div>)}
      </div>
      <div className={styles.button_container}>
        <Button caption={props.button_params.cta} on_click={handle_click}
          color="transparent" size="xs"/>
      </div>
    </div>;
};

interface i_choose_your_vpn_cards_props {
    title?: string;
    description?: string;
    with_badges?: boolean;
    gap_height?: number;
}

export const Choose_your_vpn_cards = (props: i_choose_your_vpn_cards_props)=>{
    const {title = 'Choose your Hola VPN',
        description, with_badges = false, gap_height} = props;
    const {theme} = useContext(Settings_context);
    const container_style =
        {'--gap-height': `${gap_height}px`} as React.CSSProperties;
    return <div className={styles.container}
      {...(gap_height && {style: container_style})}>
      <div className={styles.header}>
        <h3>{title}</h3>
        {description && <p className={cn([theme.u2, theme.med])}>
          {description}</p>}
      </div>
      <div className={styles.cards_container}>
        {cards_data.map(card=><Card key={card.title} {...card}
          with_badge={with_badges} />)}
      </div>
    </div>;
};

interface i_choose_your_vpn_cards_editor_props {
    value: i_choose_your_vpn_cards_props;
    on_change: (value: i_choose_your_vpn_cards_props)=>void;
}

export const Choose_your_vpn_cards_editor = (
props: i_choose_your_vpn_cards_editor_props)=>{
    return <Editor value={props.value} on_change={props.on_change}
      editors={[
        {label: 'Title', type: 'text', key: 'title'},
        {label: 'Description', type: 'text', key: 'description'},
        {label: 'With badges', type: 'boolean', key: 'with_badges'},
        {label: 'Gap height (px)', type: 'number', key: 'gap_height'},
      ]} />;
};
